import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "login-page" }
const _hoisted_3 = { class: "login-icon" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "login-title" }
const _hoisted_6 = { class: "mobile" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginForm = _resolveComponent("LoginForm")!
  const _component_PortailMobile = _resolveComponent("PortailMobile")!
  const _component_HomePageAuthenticationModale = _resolveComponent("HomePageAuthenticationModale")!
  const _component_WaitingModal = _resolveComponent("WaitingModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            src: _ctx.loadIcon,
            alt: "Logo"
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('app.name')), 1)
        ]),
        _createVNode(_component_LoginForm, {
          "old-login": _ctx.isOldLogin,
          onDataLogin: _ctx.login
        }, null, 8, ["old-login", "onDataLogin"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_PortailMobile)
      ])
    ]),
    (!_ctx.isB2cAccountValid)
      ? (_openBlock(), _createBlock(_component_HomePageAuthenticationModale, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.registerMailLoading || _ctx.authLoading)
      ? (_openBlock(), _createBlock(_component_WaitingModal, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}